var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGardenFacadeRoof(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1151_48155)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5537 20C37.5537 30.0415 29.4509 38.1818 19.4556 38.1818C9.46023 38.1818 1.35742 30.0415 1.35742 20C1.35742 9.95844 9.46023 1.81818 19.4556 1.81818C29.4509 1.81818 37.5537 9.95844 37.5537 20Z",
    fill: "#9FD9B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.643555 11.3613C0.711875 11.3986 2.01449 18.0713 2.01449 18.0713C2.01449 18.0713 1.94843 18.1913 2.7357 18.6895L15.4931 26.4681C15.4931 26.4681 15.8537 26.6331 16.4116 26.3036L23.8228 21.7572C23.8228 21.7572 24.3146 21.3613 24.6756 19.7472L26.3045 14.1354L0.643555 11.3613Z",
    fill: "#9190AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8857 26.4982L16.0179 19.2527L26.3044 13.7836L24.5787 20.1409C24.5787 20.1409 24.1951 21.5282 23.8231 21.7568L15.8857 26.4982Z",
    fill: "#747389"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00353933 10.7304V10.0082C-0.0489453 9.59361 0.593087 9.17134 0.593087 9.17134L10.1693 4.38316C10.9565 3.9877 11.8311 4.38316 11.8311 4.38316L26.3042 12.1586C26.6707 12.3554 26.7884 12.5536 26.7861 12.7304L26.7893 12.7295V13.6113L26.7757 13.6086C26.7046 13.9136 26.3042 14.135 26.3042 14.135L17.2529 19.1868C16.2032 19.8459 15.1105 19.1868 15.1105 19.1868L0.330211 11.1918C0.113033 11.0718 0.0207326 10.9359 0.00308687 10.7991C0.000488281 10.7759 0.00218197 10.7532 0.00308687 10.7304",
    fill: "#747389"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3042 12.1586L11.8307 4.38316C11.8307 4.38316 10.9561 3.9877 10.1688 4.38316L0.593086 9.17134C0.593086 9.17134 -0.54393 9.91815 0.330663 10.4013L15.1101 18.3963C15.1101 18.3963 16.2032 19.0554 17.2529 18.3963L26.3042 13.3445C26.3042 13.3445 27.3955 12.7445 26.3042 12.1582",
    fill: "#ACABC0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8484 4.61407L10.7466 8.91317L4.89409 12.2882L0.813406 10.0573C0.813406 10.0573 0.656405 9.70271 1.52014 9.28817L10.8484 4.61407Z",
    fill: "#747389"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5963 12.2754L11.601 4.76636C11.601 4.76636 11.0183 4.42045 10.7794 4.65999L10.6201 8.92045L21.7202 15.2654L25.5959 13.1541C25.5959 13.1541 26.1415 12.5677 25.5963 12.2754Z",
    fill: "#9190AC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1503 15.0359C22.1503 15.0359 14.1482 10.2909 11.59 9.17134C11.59 9.17134 10.5082 8.57816 9.75396 8.94088C9.75396 8.94088 5.09685 11.1482 4.96564 11.4772L4.58105 12.1182L15.0992 17.8363C15.0992 17.8363 16.2471 18.4622 17.2145 17.6713L22.1503 15.0359Z",
    fill: "#C4C4C4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7823 32.9773L17.5688 28.6914L19.1977 27.5227L20.2447 28.185L21.6798 27.25L20.8654 26.6655L22.4685 25.4968L23.3118 26.0032L24.7823 25.2023L24.0453 24.6396L25.8293 23.315L26.6048 23.9382L28.04 23.0032L27.3418 22.5746L29.0096 21.445L29.7462 21.9123L31.2203 20.9773L30.5221 20.3927L32.0342 19.5637L38.5496 24.1332L24.7823 32.9773Z",
    fill: "#828688"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7822 32.9772L22.2412 31.4677L36.3695 22.6041L38.5495 24.1332L24.7822 32.9772Z",
    fill: "#743438"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7823 32.51L17.5688 28.2241L19.1977 27.0555L20.2447 27.7177L21.6798 26.7827L20.8654 26.1982L22.4685 25.0291L23.3118 25.5359L24.7823 24.735L24.0453 24.1723L25.8293 22.8477L26.6048 23.4709L28.04 22.5359L27.3418 22.1073L29.0096 20.9773L29.7462 21.445L31.2203 20.51L30.5221 19.9255L32.0342 19.0964L38.5496 23.6655L24.7823 32.51Z",
    fill: "#E5E5E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7822 32.51L22.2412 31.0005L36.3695 22.1368L38.5495 23.6655L24.7822 32.51Z",
    fill: "#914146"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5688 28.6918V28.2246L18.5724 28.8205L17.5688 28.6918ZM20.865 26.1982V26.7241L21.226 26.9246L21.3713 26.5614L20.865 26.1982ZM24.0453 24.64V24.1727L24.7823 24.735L24.0453 24.64ZM27.3414 22.575V22.1078L27.9468 22.4791L27.7201 22.6046L27.3414 22.575ZM30.5217 20.3932V19.9255L31.1189 20.4259L30.5217 20.3932Z",
    fill: "#828688"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2412 31.4682V31.0004L24.7822 32.51V32.9772L22.2412 31.4682Z",
    fill: "#743438"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2166 31.0909L31.966 27.5618C31.966 27.5618 31.3262 27.4159 30.9769 27.825C30.9769 27.825 30.7344 28.3995 30.9769 28.7309L38.1723 33.4036L39.2166 31.0909Z",
    fill: "#914146"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6476 31.7014L30.9771 27.825C30.9771 27.825 30.7156 28.4482 30.9771 28.7305L38.196 33.415L37.6485 31.7014H37.6476Z",
    fill: "#743438"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1151_48155",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 30,
    width: 3,
    height: 4
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4702 30.995H39.9999V33.5368H37.4702V30.995Z",
    fill: "#7A7A7A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1151_48155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4702 32.2659C37.4702 32.9677 38.0362 33.5368 38.7348 33.5368C39.4334 33.5368 39.9999 32.9677 39.9999 32.2659C39.9999 31.5641 39.4334 30.995 38.7348 30.995C38.0362 30.995 37.4702 31.5641 37.4702 32.2659Z",
    fill: "#7A7A7A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1151_48155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGardenFacadeRoof);
export default __webpack_public_path__ + "static/media/garden-facade-roof.cf97276ae7766467c77213c618d4210b.svg";
export { ForwardRef as ReactComponent };